// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Force banner to bottom - highest specificity - override ANY positioning */
html body > .model-status-banner,
html body .model-status-banner,
body > .model-status-banner,
body .model-status-banner,
#root .model-status-banner,
.App .model-status-banner,
.model-status-banner {
  position: fixed !important;
  bottom: 10px !important;
  top: auto !important;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
  z-index: 1100 !important;
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(220, 38, 38, 0.2)) !important;
  border: 1px solid rgba(239, 68, 68, 0.4) !important;
  border-radius: 8px !important;
  padding: 0.875rem 2rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 300px !important;
  max-width: 600px !important;
  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2) !important;
  animation: slideUp 0.3s ease-out !important;
  backdrop-filter: blur(10px) !important;
  margin: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  /* Explicitly override any top positioning */
  top: unset !important;
  /* Ensure it's not affected by any parent positioning */
  width: auto !important;
  height: auto !important;
  /* Force it to stay at bottom - override any inline styles or other CSS */
  inset: auto auto 10px 50% !important;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.model-status-message {
  color: #ef4444;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.4;
}

.model-status-dismiss {
  background: none;
  border: none;
  color: rgba(239, 68, 68, 0.6);
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0 0 0 1rem;
  line-height: 1;
  font-weight: 600;
}

.model-status-dismiss:hover {
  color: #ef4444;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .model-status-banner {
    position: fixed !important;
    bottom: 10px !important;
    top: auto !important;
    left: 1rem;
    right: 1rem;
    transform: none;
    max-width: none;
    min-width: auto;
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .model-status-message {
    font-size: 0.9rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/ModelStatusBanner.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;;;;;;;EAOE,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,sCAAsC;EACtC,wBAAwB;EACxB,8FAA8F;EAC9F,mDAAmD;EACnD,6BAA6B;EAC7B,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,wDAAwD;EACxD,2CAA2C;EAC3C,sCAAsC;EACtC,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;EACrB,uDAAuD;EACvD,sBAAsB;EACtB,uBAAuB;EACvB,yEAAyE;EACzE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;IACV,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;EACjB;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Force banner to bottom - highest specificity - override ANY positioning */\nhtml body > .model-status-banner,\nhtml body .model-status-banner,\nbody > .model-status-banner,\nbody .model-status-banner,\n#root .model-status-banner,\n.App .model-status-banner,\n.model-status-banner {\n  position: fixed !important;\n  bottom: 10px !important;\n  top: auto !important;\n  left: 50% !important;\n  right: auto !important;\n  transform: translateX(-50%) !important;\n  z-index: 1100 !important;\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(220, 38, 38, 0.2)) !important;\n  border: 1px solid rgba(239, 68, 68, 0.4) !important;\n  border-radius: 8px !important;\n  padding: 0.875rem 2rem !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  min-width: 300px !important;\n  max-width: 600px !important;\n  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2) !important;\n  animation: slideUp 0.3s ease-out !important;\n  backdrop-filter: blur(10px) !important;\n  margin: 0 !important;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  /* Explicitly override any top positioning */\n  top: unset !important;\n  /* Ensure it's not affected by any parent positioning */\n  width: auto !important;\n  height: auto !important;\n  /* Force it to stay at bottom - override any inline styles or other CSS */\n  inset: auto auto 10px 50% !important;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.model-status-message {\n  color: #ef4444;\n  font-size: 1rem;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.model-status-dismiss {\n  background: none;\n  border: none;\n  color: rgba(239, 68, 68, 0.6);\n  font-size: 1.1rem;\n  cursor: pointer;\n  padding: 0 0 0 1rem;\n  line-height: 1;\n  font-weight: 600;\n}\n\n.model-status-dismiss:hover {\n  color: #ef4444;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .model-status-banner {\n    position: fixed !important;\n    bottom: 10px !important;\n    top: auto !important;\n    left: 1rem;\n    right: 1rem;\n    transform: none;\n    max-width: none;\n    min-width: auto;\n  }\n\n  @keyframes slideUp {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .model-status-message {\n    font-size: 0.9rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
